import { get, post, put, remove } from "@/utils/request";
import { TDocumentTemplateDTO, TDocumentCatalogDTO, QueryParams, ResponseData } from '../template/type';

/** 文档模板 */
// 获取文档模板列表
export const getDocumentTemplateList = (params: QueryParams) => {
    return get<ResponseData<TDocumentTemplateDTO[]>>(`/cmp-doc/tmpl/doc/list`, params, {}, 'document');
};

// 新增文档模板
export const addDocumentTemplate = (data: TDocumentTemplateDTO) => {
    return post<ResponseData<any>>(`/cmp-doc/tmpl/doc/add`, data, {}, 'document');
};

// 更新文档模板
export const updateDocumentTemplate = (id: string, data: Partial<TDocumentTemplateDTO>) => {
    return put<ResponseData<any>>(`/cmp-doc/tmpl/doc/${id}`, data, {}, 'document');
};

// 删除文档模板
export const deleteDocumentTemplate = (id: string) => {
    return remove<ResponseData<any>>(`/cmp-doc/tmpl/doc/${id}`, {}, {}, 'document');
};

// 启用/禁用文档模板
export const toggleDocumentTemplateStatus = (id: string, isEnabled: number) => {
    return put<ResponseData<any>>(`/cmp-doc/tmpl/doc/toggle-enable?id=${id}&isEnabled=${isEnabled}`, {}, {}, 'document');
};

/** 文档目录 */
// 获取文档目录列表
export const getDocumentCatalogList = (params: QueryParams) => {
    return get<ResponseData<TDocumentCatalogDTO[]>>(`/cmp-doc/tmpl/docDir/list`, params, {}, 'document');
};

// 新增文档目录
export const addDocumentCatalog = (data: TDocumentCatalogDTO) => {
    return post<ResponseData<any>>(`/cmp-doc/tmpl/docDir/add`, data, {}, 'document');
};

// 更新文档目录
export const updateDocumentCatalog = (id: string, data: Partial<TDocumentCatalogDTO>) => {
    return put<ResponseData<any>>(`/cmp-doc/tmpl/docDir/${id}`, data, {}, 'document');
};

// 删除文档目录
export const deleteDocumentCatalog = (id: string) => {
    return remove<ResponseData<any>>(`/cmp-doc/tmpl/docDir/${id}`, {}, {}, 'document');
};

// 启用/禁用文档目录
export const toggleDocumentCatalogStatus = (id: string, isEnabled: number) => {
    return put<ResponseData<any>>(`/cmp-doc/tmpl/docDir/enable?id=${id}&isEnabled=${isEnabled}`, {}, {}, 'document');
};

// 关联文档到目录
export const associateDocuments = (catalogId: string, documentIds: string[]) => {
    return post<ResponseData<any>>(`/cmp-doc/tmpl/docDir/associate/${catalogId}`, { documentIds }, {}, 'document');
};

// 移除目录中的文档
export const removeDocumentFromCatalog = (catalogId: string, documentId: string) => {
    return remove<ResponseData<any>>(`/cmp-doc/tmpl/docDir/remove/${catalogId}/${documentId}`, {}, {}, 'document');
};